import IntroImage from './IntroImage';
import TitleWithCustomContent from './TitleWithCustomContent';
import Image from './Image';
import LargeTitle from './LargeTitle';
import DescriptiveLinks from './DescriptiveLinks';
import Contact from './Contact';
import RelatedProjects from './RelatedProjects';
import NewsAndLinks from './NewsAndLinks';
import RichText from './RichText';

export default {
    intro_image: IntroImage,
    title_with_custom_content: TitleWithCustomContent,
    image: Image,
    large_title: LargeTitle,
    descriptive_links: DescriptiveLinks,
    contact: Contact,
    related_projects: RelatedProjects,
    news_and_links: NewsAndLinks,
    rich_text: RichText
}


// WEBPACK FOOTER //
// ./src/partials/modules/index.js